import React, { Component, useEffect, useState } from "react";
import Titulo from "../../../generico/TituloPagina";
import DatosSocio from "../../../generico/DatosSocio"
import Switch from "react-switch";
import { formatoSeparadorMiles, formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import ConfiguracionTarjetaService from "../../../../services/autogestion/ConfiguracionTarjetaService";
import { trackPromise } from "react-promise-tracker";
import $ from "jquery"
import Popup from "react-popup";
import history from "../../login/history";
import TarjetaService from "../../../../services/pagos/TarjetaService";
import { ESTADO_TARJETA, MENSAJE, OPERACION_TARJETA } from "../../../generico/utils/Constantes";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faArrowAltCircleUp } from "@fortawesome/free-solid-svg-icons";

const Canal = ({ canalList, onChangeCheckbox, onChangeMonto, formatoMontoLimite, formatoSeparadorMiles }) => {

  const handleChangeCheckbox = (e) => onChangeCheckbox(e)

  const handleChangeMonto = (e) => onChangeMonto(e)

  const canal = canalList.map((canalValue) => {

    let { canal, canalDesc, canalSts, canalLimDia, canalLimMes } = canalValue;
    canalSts = (canalSts === "A") ? true : false;

    return (
      <tbody id={canal} key={canal + "_canal"}>
        <tr style={{ height: 30 }}>
          <td style={{ width: "85%" }}>
            {canalDesc}
          </td>
          <td style={{ textAlign: "center" }}>
            <input id={canal} type="checkbox" onChange={handleChangeCheckbox} className="check-conf-tarjeta" name="canal" defaultChecked={canalSts} />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div className="form-group m-2">
              <label className="input-label">
                Límite Diario (Gs.)
              </label>
              <input
                type="text"
                name="limiteDiarioCanal"
                placeholder="Sin límite"
                onKeyUp={formatoSeparadorMiles}
                maxLength="17"
                className="form-control input-box"
                style={{ textTransform: "lowercase" }}
                previousvalue={canalLimDia}
                disabled={!canalSts}
                value={formatoMontoLimite(canalLimDia)}
                onChange={handleChangeMonto} />
            </div>
            <div className="form-group m-2">
              <label className="input-label">
                Límite Mensual (Gs.)
              </label>
              <input
                type="text"
                name="limiteMensualCanal"
                placeholder="Sin límite"
                onKeyUp={formatoSeparadorMiles}
                maxLength="17"
                className="form-control input-box"
                style={{ textTransform: "lowercase" }}
                previousvalue={canalLimMes}
                disabled={!canalSts}
                value={formatoMontoLimite(canalLimMes)}
                onChange={handleChangeMonto} />
            </div>
          </td>
        </tr>
      </tbody>
    )
  });

  return (
    <div className="card" style={{ boxShadow: "none", border: "1px solid #efefef" }}>
      <div className="card-header border-0">
        <label className="input-label-bold">Canales Habilitados</label>
      </div>
      <div className="card-body table-responsive p-0">
        <table className="table table-striped table-valign-middle">
          {canal}
        </table>
      </div>
    </div >
  );
}

const CanalItem = ({ canalValue, onChangeCheckbox, onChangeMonto, formatoMontoLimite, formatoSeparadorMiles }) => {
  const handleChangeCheckbox = (e) => onChangeCheckbox(e)
  const handleChangeMonto = (e) => onChangeMonto(e)
  let { canal, canalDesc, canalSts, canalLimDia, canalLimMes } = canalValue;
  canalSts = (canalSts === "A") ? true : false;
  if (canalValue.canal === 'WEB') {
    return (
      <tbody id={canal} key={canal + "_canal"}>
        <tr style={{ height: 30 }}>
          <td style={{ width: "85%" }}>
            {canalDesc}
          </td>
          <td style={{ textAlign: "center" }}>
            <input id={canal} type="checkbox" onChange={handleChangeCheckbox} className="check-conf-tarjeta" name="canal" defaultChecked={canalSts} />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div className="form-group m-2" >
              <label className="input-label">
                Límite Diario (Gs.)
              </label>
              {
                !canalSts ? <span style={{ flexDirection: "row", alignItems: "center", display: "inline-flex", backgroundColor: "#e9ecef" }} className="m-0 form-control input-box">{canalLimDia === "" ? "sin límite" : formatoMontoLimite(canalLimDia)}</span> :
                  <input
                    type="text"
                    name="limiteDiarioCanal"
                    placeholder="Sin límite"
                    onKeyUp={formatoSeparadorMiles}
                    maxLength="17"
                    className="form-control input-box"
                    style={{ textTransform: "lowercase", flexDirection: "row", alignItems: "center", display: "inline-flex" }}
                    previousvalue={canalLimDia}
                    value={formatoMontoLimite(canalLimDia)}
                    onChange={handleChangeMonto} />
              }
            </div>
            <div className="form-group m-2">
              <label className="input-label">
                Límite Mensual (Gs.)
              </label>
              {
                !canalSts ? <span style={{ flexDirection: "row", alignItems: "center", display: "inline-flex", backgroundColor: "#e9ecef" }} className="m-0 form-control input-box">{canalLimMes === "" ? "sin límite" : formatoMontoLimite(canalLimMes)}</span> :
                  <input
                    type="text"
                    name="limiteMensualCanal"
                    placeholder="Sin límite"
                    onKeyUp={formatoSeparadorMiles}
                    maxLength="17"
                    className="form-control input-box"
                    style={{ textTransform: "lowercase", flexDirection: "row", alignItems: "center", display: "inline-flex" }}
                    previousvalue={canalLimMes}
                    value={formatoMontoLimite(canalLimMes)}
                    onChange={handleChangeMonto} />
              }
            </div>
          </td>
        </tr>
      </tbody >
    )
  } else {
    return (

      <tr style={{ height: 30 }}>
        <td style={{ width: "85%" }}>
          {canalDesc}
        </td>
        <td style={{ textAlign: "center" }}>
          <input id={canal} type="checkbox" onChange={handleChangeCheckbox} className="check-conf-tarjeta" name="canal" defaultChecked={canalSts} />
        </td>
      </tr>

    )
  }
};

const CanalList = ({ items, onChangeCheckbox, onChangeMonto, formatoMontoLimite, formatoSeparadorMiles }) => {
  return (
    <div className="card" style={{ boxShadow: "none", border: "1px solid #efefef" }}>
      <div className="card-header border-0">
        <label className="input-label-bold">Canales Habilitados</label>
      </div>
      <div className="card-body table-responsive p-0">
        <form>
          <table className="table table-striped table-valign-middle">
            {
              items.map((canalValue, index) =>
                <CanalItem
                  key={index}
                  canalValue={canalValue}
                  onChangeCheckbox={onChangeCheckbox}
                  onChangeMonto={onChangeMonto}
                  formatoMontoLimite={formatoMontoLimite}
                  formatoSeparadorMiles={formatoSeparadorMiles}
                />
              )
            }
          </table>
        </form>
      </div>
    </div >

  );
}

const Rubro = ({ rubroList, onChangeCheckbox }) => {

  const handleChangeCheckbox = (e) => {
    onChangeCheckbox(e);
  }

  const rubro = rubroList.map((rubro) => {
    let { tcc, tccDes, tccSts } = rubro;
    tccSts = rubro.tccSts === "A" ? true : false;
    return (
      <tr key={tcc + "_rubro"} style={{ height: 30 }} >
        <td style={{ width: "85%" }}>
          {tccDes}
        </td>
        <td style={{ textAlign: "center" }}>
          <input id={tcc} type="checkbox" onChange={handleChangeCheckbox} className="check-conf-tarjeta" name="rubro" defaultChecked={tccSts} />
        </td>
      </tr >
    )
  });
  return (
    <div className="card" style={{ boxShadow: "none", border: "1px solid #efefef" }}>
      <div className="card-header border-0">
        <label className="input-label-bold">Rubros Habilitados</label>
      </div>
      <div className="card-body table-responsive p-0">
        <table className="table table-striped table-valign-middle">
          <tbody>
            {rubro}
          </tbody>
        </table>
      </div>
    </div >
  );
}

const Pais = ({ paisList, onChangeCheckbox }) => {

  const handleChangeCheckbox = (e) => {
    onChangeCheckbox(e);
  }

  const pais = paisList.map((paisValue) => {
    let { pais, paisDesc, paisSts } = paisValue;
    paisSts = paisSts === "A" ? true : false;
    return (
      <tr key={pais + "_pais"} style={{ height: 30 }}>
        <td style={{ width: "85%" }}>
          {paisDesc}
        </td>
        <td style={{ textAlign: "center" }}>
          <input id={pais} type="checkbox" onChange={handleChangeCheckbox} className="check-conf-tarjeta" name="pais" defaultChecked={paisSts} />
        </td>
      </tr>
    )
  });
  return (
    <div className="card" style={{ boxShadow: "none", border: "1px solid #efefef" }}>
      <div className="card-header border-0">
        <label className="input-label-bold">Países</label>
        <span> (lugares donde puede comprar presencialmente y por internet)</span>
      </div>
      <div className="card-body table-responsive p-0">
        <table className="table table-striped table-valign-middle">
          <tbody>
            {pais}
          </tbody>
        </table>
      </div>

    </div>
  );
}

const SwitchTarjetaCretido = ({ tarjetaSeleccionada, estadoSwitch, onChangeEstadoTarjeta }) => {

  const handleChangeTarjetaEstado = (e) => {
    onChangeEstadoTarjeta(e);
  }

  return (
    <div className="row card-tarjeta">
      <div className="col-md-8">
        <div className="col-md-12 col-lg-4" style={{ fontWeight: 500 }}>
          <div className="tarjeta-imagen">
            <img src={tarjetaSeleccionada?.tarjetaURL} className="img-tarjeta w-100" alt="Imagen de la Tarjeta" /*width="200px" height="100%"*/ />
          </div>
        </div>
        <div className="col-md-12 col-lg-8" style={{ fontWeight: 500 }}>
          <div className="row" style={{ paddingTop: 15 }}>
            <div className="col-md-12" style={{ fontWeight: 500 }}>
              <span className="dato" style={{ fontWeight: 500, fontSize: 20 }}>{tarjetaSeleccionada?.tipo}</span>
            </div>
            <div className="col-md-12">
              <span className="dato">Línea: <b className="input-label-bold">{tarjetaSeleccionada?.linea}</b></span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 col-12 col-md-4">
        <div className=" align-items-center">
          <div className="row" style={{ paddingTop: 0 }}>
            <div className="col-md-10 col-12">
              <div className="aviso-box">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6">
                      <FontAwesomeIcon className="item-trash" icon={faExclamationCircle} />
                    </div>
                    <div className="col-md-6">
                      <h5>Aviso</h5>
                    </div>
                  </div>
                </div>

                <div className="col-md-10" style={{ display: "grid", justifyContent: "center" }}>
                  <div className="row">
                    <div className="col-md-12">
                      <span ><b className="input-label-bold">Apagado:</b>  bloquea la tarjeta. </span>
                    </div>
                    <div className="col-md-12">
                      <span> <b className="input-label-bold">Encendido:</b> desbloquea la tarjeta. </span>
                    </div>

                  </div>

                </div>
              </div>

              <div className="col-md-10" style={{ display: "grid", justifyContent: "center" }}>

                <span className="input-label text-apagado-encendido mr-3">Apagado/Encendido </span>
                <Switch id="apagar-tarjeta"
                  onChange={handleChangeTarjetaEstado}
                  checked={estadoSwitch}
                  className="react-switch"
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  onColor="#EAAC24" />
              </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      )

}

      const BotonGuardar = ({children, disabled, onClick}) => {

  const handleOnClick = (e) => {
        onClick(e);
  }

      return (
      <button
        type="submit"
        className="btn btn-cu-primary float-right"
        disabled={disabled}
        onClick={handleOnClick}
      >
        {children}
      </button>
      )
}

      export default class ConfigurarTarjeta extends Component {

        constructor(props) {
        super(props);

      this.state = this.getInitialState();
      this.nuevoPinRef = React.createRef();
      this.confirmarPinRef = React.createRef();

      this.onChangeEstadoTarjeta = this.onChangeEstadoTarjeta.bind(this);
      this.confirmarCambioEstadoTarjeta = this.confirmarCambioEstadoTarjeta.bind(this);

  }

  getInitialState = () => {

        let tarjetaSeleccionada = JSON.parse(sessionStorage.getItem("tarjetaSeleccionada"));

      if (!tarjetaSeleccionada) history.goBack();

      return {
        mostrarFormulario: false,
      changeDataCount: 0,
      originalData: null,
      tarjetaSeleccionada,
      canalList: [],
      rubroList: [],
      paisList: [],
      paisesAdicionales: [],
      tarjetaEstado: "",
      bloquearDesbloquearTarjeta: "",
      activarInactivarTarjeta: "",
      infoTarjeta: null,
      pinNuevo: "",
      pinNuevoConfirmar: "",
      limiteDiario: '',
      limiteMensual: '',
    }
  };

      componentDidMount() {

        let tarjetaSeleccionada = JSON.parse(sessionStorage.getItem("tarjetaSeleccionada"));
      this.setState({tarjetaSeleccionada});

      if (tarjetaSeleccionada?.tipoDesc === "Master") {
        $("input").attr("disabled", true);
      $("[name=btn-agregar-paises]").attr("disabled", true);
      this.obtenerParametrosTarjeta();
    } else {
        this.getInfoTarjeta();
    }

  }

      componentDidUpdate() {
    if (this.state.activarInactivarTarjeta !== "") this.cargarParametrosTarjeta();
  }

  notifiPopup = (titulo, mensaje, callback = undefined) =>
      Popup.register({
        title: titulo,
      content: mensaje,
      buttons: {
        right: [
      {
        text: "Aceptar",
      className: "success",
      action: function () {
        callback && callback();
      Popup.close();
            },
          },
      ],
      },
    });

  notifiPopupConfirmar = (titulo, mensaje, callback) =>
      Popup.register({
        title: titulo,
      content: mensaje,
      buttons: {
        right: [
      {
        text: "Cancelar",
      className: "secundary",
      action: function () {
        Popup.close();
            },
          },
      {
        text: "Continuar",
      className: "success",
      action: function () {
        callback && callback();
      Popup.close();
            },
          },
      ],
      left: [],
      },

    });


  getInfoTarjeta = () => {
        trackPromise(
          TarjetaService.getInfoTarjeta()
            .then(response => {

              let { tarjetaSeleccionada } = this.state;
              let { data, header } = response.data;

              if (header.codReturn === "0") {

                if (data.length === 0) {
                  Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, history.goBack));
                  return null;
                }

                let infoTarjeta = data.find(element => element.NUMERO_TARJETA === tarjetaSeleccionada.nroTarjetaCompleto);
                let initialState = this.getInitialState();
                this.setState({ ...initialState, infoTarjeta, tarjetaEstado: infoTarjeta.ESTADO });

              } else {
                Popup.queue(this.notifiPopup("Info", data.txtReturn, history.goBack));
              }

            })
            .catch(error => {
              console.log(error);
              Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, history.goBack));
            })
        )
      }


  cargarParametrosTarjeta = () => {

    const SIN_LIMITES = 9999999999999;

      let {tarjetaEstado, canalList, rubroList, paisList, limiteDiario, limiteMensual, tarjetaSeleccionada} = this.state;
      let prevState = this.state;

      limiteDiario = (limiteDiario === "" || limiteDiario === 0) ? SIN_LIMITES : limiteDiario;
      limiteMensual = (limiteMensual === "" || limiteMensual === 0) ? SIN_LIMITES : limiteMensual;
    canalList = canalList.map(canal => (
      {
        ...canal,
        canalLimDia: canal.canalLimDia === 0 || canal.canalLimDia === "" ? SIN_LIMITES : canal.canalLimDia,
      canalLimMes: canal.canalLimMes === 0 || canal.canalLimMes === "" ? SIN_LIMITES : canal.canalLimMes
      }
      ));

      let dataToPost = {

        "parametros": {
        "tarjeta": {
        "trjSts": tarjetaEstado,
      "ctaid": tarjetaSeleccionada.cuenta,
      "trjEnm": tarjetaSeleccionada.nroTarjetaMaster,
        },
      "limitesGenerales": {
        "diario": limiteDiario,
      "mensual": limiteMensual
        },
      "canales": {
        "canalItem": canalList
        },
      "paises": {
        "paisItem": paisList
        },
      "tccs": {
        "tccItem": rubroList
        }
      }
    }

    let callback = (newOriginalData) => {

        let originalData = {
        ...newOriginalData,
        tccs: {
        tccitem: newOriginalData.tccs.tccItem
        }
      }

      this.setState({originalData, changeDataCount: 0, activarInactivarTarjeta: "" });
      $(".change-value").removeClass("change-value");
    }

      trackPromise(
      ConfiguracionTarjetaService.setParametrosTarjeta(dataToPost)
        .then(response => {

        let data = response.data;
          Popup.queue(this.notifiPopup("Info", data.mensajeRetorno, () => callback(dataToPost.parametros)));

        })
        .catch(error => {
        console.log(error);
      Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, callback));
        })
      )
  }

  obtenerParametrosTarjeta = () => {

    const SIN_LIMITES = 9999999999999;

      let {tarjetaSeleccionada} = this.state;
      let parametros = {
        ctaid: tarjetaSeleccionada.cuenta,
      av30Trjenm: tarjetaSeleccionada.nroTarjetaMaster
    };
      trackPromise(
      ConfiguracionTarjetaService.getParametrosTarjeta(parametros)
        .then(response => {
        let data = response.data;
      let datos = response.data.datos;

          let paisesAdicionales = datos.paises.paisItem.map((pais) => {
            return {
        ...pais,
        enabled: pais.paisSts === "I" ? false : true,
            };
          });

          datos.canales.canalItem.forEach(canal => {
        canal.canalLimDia = canal.canalLimDia === SIN_LIMITES ? "" : canal.canalLimDia;
      canal.canalLimMes = canal.canalLimMes === SIN_LIMITES ? "" : canal.canalLimMes;
          });

      this.setState({
        originalData: datos,
      canalList: datos.canales.canalItem,
      rubroList: datos.tccs.tccitem,
      paisList: datos.paises.paisItem,
      paisesAdicionales,
      tarjetaEstado: datos.tarjeta.trjSts,
      mostrarFormulario: true,
      limiteDiario: datos.limitesGenerales.diario,
      limiteMensual: datos.limitesGenerales.mensual
          });

      let disableInput = datos.tarjeta.trjSts === "A" ? false : true;
      $("input").attr("disabled", disableInput);
      $("[name=btn-agregar-paises]").attr("disabled", disableInput);

        })
        .catch(error => {
        console.log(error);
      Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, history.goBack));
        })
      )
  }

      confirmarCambioEstadoTarjeta(operacion) {

        let {tarjetaSeleccionada} = this.state;

      let accion = tarjetaSeleccionada.tipoDesc === "Master"
      ? operacion ? "activada" : "desactivada"
      : operacion ? "desbloqueada" : "bloqueada"

      Popup.queue(
      this.notifiPopupConfirmar(
      "Atención",
      `La Tarjeta será ${accion}, ¿Está seguro que desea continuar?`,
        () => this.onChangeEstadoTarjeta(operacion, tarjetaSeleccionada.tipoDesc)
      )
      );

  }

      /**
       * apagado/encendido tarjeta
       */

      onChangeEstadoTarjeta(estadoNuevo, tipoTarjeta) {

    if (tipoTarjeta === "Master") {

        let {activarInactivarTarjeta} = this.state;

      estadoNuevo = estadoNuevo ? ESTADO_TARJETA.MASTER.ACTIVO : ESTADO_TARJETA.MASTER.INACTIVO;
      activarInactivarTarjeta = estadoNuevo;

      let disableInput = estadoNuevo === ESTADO_TARJETA.MASTER.ACTIVO ? false : true;

      this.setState({tarjetaEstado: estadoNuevo, activarInactivarTarjeta });

      $("input").attr("disabled", disableInput);
      $("[name=btn-agregar-paises]").attr("disabled", disableInput);

    } else {

        let {bloquearDesbloquearTarjeta} = this.state;
      bloquearDesbloquearTarjeta = estadoNuevo ? OPERACION_TARJETA.CABAL.DESBLOQUEAR : OPERACION_TARJETA.CABAL.BLOQUEAR;
      estadoNuevo = estadoNuevo ? ESTADO_TARJETA.CABAL.ACTIVO : ESTADO_TARJETA.CABAL.BLOQUEADO;
      this.setState({tarjetaEstado: estadoNuevo, bloquearDesbloquearTarjeta });

    }

  }

  bloqueoDesbloqueoTarjeta = () => {

        let {infoTarjeta, bloquearDesbloquearTarjeta} = this.state;

      let paramData = {
        numeroTarjeta: infoTarjeta.NUMERO_TARJETA,
      tipoOperacion: bloquearDesbloquearTarjeta
    }

      trackPromise(
      TarjetaService.bloqueoDesbloqueoTarjeta(paramData)
        .then(response => {
        let {data, header} = response.data;
          Popup.queue(this.notifiPopup("Info", header.txtReturn, () => {
        this.setState({ bloquearDesbloquearTarjeta: "" });
          }));
        })
        .catch(error => {
        console.log(error);
          Popup.queue(this.notifiPopup("Info", MENSAJE.ERROR_INESPERADO, () => {
        this.getInfoTarjeta();
          }));
        })
      )
  }

  onChangeCheckbox = (e) => {

        let checkboxName = e.target.name;

      let {originalData, changeDataCount, canalList, rubroList, paisList} = this.state;
      let newState = null;
      let changeData = false;
      let currentSts = e.target.checked ? "A" : "I";

      switch (checkboxName) {
      case "canal":
        newState = canalList.map(canal => (
      e.target.id === canal.canal
      ? {...canal, canalSts: currentSts }
      : canal
      ));
        changeData = originalData.canales.canalItem.some(canal =>
      e.target.id === canal.canal && canal.canalSts !== currentSts
      );
      changeDataCount = changeData ? changeDataCount + 1 : changeDataCount - 1;
      this.setState({canalList: newState, changeDataCount });
      break;
      case "rubro":
        newState = rubroList.map(rubro => (
      e.target.id === rubro.tcc
      ? {...rubro, tccSts: currentSts }
      : rubro
      ));
        changeData = originalData.tccs.tccitem.some(tcc =>
      e.target.id === tcc.tcc && tcc.tccSts !== currentSts
      );
      changeDataCount = changeData ? changeDataCount + 1 : changeDataCount - 1;
      this.setState({rubroList: newState, changeDataCount });
      break;
      default:

        newState = paisList.map(pais => (
      e.target.id === pais.pais.toString()
      ? {...pais, paisSts: currentSts }
      : pais
      ));

      if (originalData.paises.paisItem.length !== paisList.length) {
        changeData = true;
        } else {
        changeData = originalData.paises.paisItem.some(pais =>
          e.target.id === pais.pais.toString() && pais.paisSts !== currentSts
        );
        }

      changeDataCount = changeData ? changeDataCount + 1 : changeDataCount - 1;
      this.setState({paisList: newState, changeDataCount });
      break;

    }
      let element = $(e.target).closest("tr");
      if (changeData) {
        $(element).addClass("change-value");
    } else {
        $(element).removeClass("change-value");
    }
  }

  onChangeMonto = (e) => {

        let {originalData, changeDataCount, canalList} = this.state;
      let target = e.target.name;
      let newState = null;
      let canalId = null;
      let changeData = false;
      let montoOriginal = null;

      let montoAnterior = $(e.target).attr("previousvalue");
      if (montoAnterior !== "") montoAnterior = parseInt(montoAnterior);

      let montoNuevo = e.target.value;

      if (montoNuevo !== "") {
      while (montoNuevo.indexOf(".") > -1) {
        montoNuevo = montoNuevo.replace(".", "");
      }
      if (montoNuevo.search(/\D/g) > -1) return null;
      montoNuevo = parseInt(montoNuevo);
    }
      switch (target) {
      case "limiteDiarioGeneral":
      montoOriginal = originalData.limitesGenerales.diario;
      changeData = montoNuevo !== montoOriginal;
      changeDataCount = changeData
      ? montoAnterior !== montoOriginal ? changeDataCount : changeDataCount + 1
      : changeDataCount - 1;
      this.setState({limiteDiario: montoNuevo, changeDataCount });
      $(e.target).attr("previousvalue", montoNuevo);
      break;
      case "limiteMensualGeneral":
      montoOriginal = originalData.limitesGenerales.mensual;
      changeData = montoNuevo !== montoOriginal;
      changeDataCount = changeData
      ? montoAnterior === montoOriginal ? changeDataCount + 1 : changeDataCount
      : changeDataCount - 1;
      this.setState({limiteMensual: montoNuevo, changeDataCount });
      $(e.target).attr("previousvalue", montoNuevo);
      break;
      case "limiteDiarioCanal":
      canalId = $(e.target).closest("tbody").attr("id");
        newState = canalList.map(canal => (
      canal.canal === canalId
      ? {...canal, canalLimDia: montoNuevo }
      : canal
      ));
      for (let canal of originalData.canales.canalItem) {
          if (canal.canal === canalId) {
        montoOriginal = canal.canalLimDia
            break;
          }
        }
      changeData = montoNuevo !== montoOriginal;
      changeDataCount = changeData
      ? montoAnterior === montoOriginal ? changeDataCount + 1 : changeDataCount
      : changeDataCount - 1;
      this.setState({canalList: newState, changeDataCount });
      e.target.value = montoNuevo;
      break;
      default:
      canalId = $(e.target).closest("tbody").attr("id");
        newState = canalList.map(canal => (
      canal.canal === canalId
      ? {...canal, canalLimMes: montoNuevo }
      : canal
      ));
      for (let canal of originalData.canales.canalItem) {
          if (canal.canal === canalId) {
        montoOriginal = canal.canalLimMes
            break;
          }
        }
      changeData = montoNuevo !== montoOriginal;
      changeDataCount = changeData
      ? montoAnterior === montoOriginal ? changeDataCount + 1 : changeDataCount
      : changeDataCount - 1;
      this.setState({canalList: newState, changeDataCount });
      e.target.value = montoNuevo;
      break;
    }
  }

  agregarPaisesSeleccionados = (listPaisesSeleccionados) => {

        let {paisList, paisesAdicionales, changeDataCount} = this.state;
      let newState = null;

      paisList = paisList.concat(listPaisesSeleccionados);

    paisesAdicionales = paisesAdicionales.map(paisAdicional =>
      paisList.some(paisItem => paisItem.pais === paisAdicional.id)
      ? {...paisAdicional, enabled: false }
      : {...paisAdicional, enabled: true }
      )

      changeDataCount = changeDataCount + 1;

      this.setState({paisList: newState, changeDataCount });
      this.setState({paisList, paisesAdicionales});

  }

  formatoMontoLimite = (value) => {
    if (value === null || value === "") return "";
      return formatoSeparadorMilesValue(value);
  }


      render() {

        let {
        canalList,
        rubroList,
        paisList,
        changeDataCount,
        tarjetaSeleccionada,
        tarjetaEstado,
        limiteDiario,
        limiteMensual,
        pinNuevo,
        pinNuevoConfirmar
      } = this.state;

      let disabledBtnGuardar = tarjetaSeleccionada.tipoDesc === "Master"
      ? changeDataCount === 0
      : !(pinNuevo.length === 6 && pinNuevoConfirmar.length === 6)

      let estadoSwitchTarjeta = tarjetaSeleccionada.tipoDesc === "Master"
      ? tarjetaEstado === ESTADO_TARJETA.MASTER.ACTIVO ? true : false
      : tarjetaEstado === ESTADO_TARJETA.CABAL.ACTIVO ? true : false

      return (
      <div className="content-wrapper">
        <Titulo texto="Configuración de Tarjeta" />
        <section className="content">
          <div className="container config-tarjeta">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <SwitchTarjetaCretido
                      tarjetaSeleccionada={tarjetaSeleccionada}
                      estadoSwitch={estadoSwitchTarjeta}
                      onChangeEstadoTarjeta={this.confirmarCambioEstadoTarjeta}
                    />
                    <br />
                    <div className="row invoice-info">
                      <div className="col-12">
                        <MensajeUsuario tipo="INFO"
                          titulo="Importante."
                          mensaje={
                            <p className="mt-1">
                              <p className="mb-1">Ud. puede habilitar o inhabilitar los Canales de compras, Rubros y Países, al marcar o desmarcar la casilla. Por defecto, todas las casillas están habilitadas.</p>
                              <p className="pr-5">Si bloquea su tarjeta en forma definitiva ya sea por robo o extravío y desea una regrabación, deberá ponerse en comunicación con el CAS al 617 0000 para solicitarla.</p>
                            </p>
                          }
                        />

                      </div>
                    </div>
                    <hr />
                    {
                      (
                        estadoSwitchTarjeta &&
                        <>
                          <h4 >Parámetros de Tarjeta</h4>
                          <br />
                          <div className="row">
                            <div className="col-lg-4">
                              <CanalList
                                items={canalList}
                                onChangeCheckbox={this.onChangeCheckbox}
                                onChangeMonto={this.onChangeMonto}
                                formatoMontoLimite={this.formatoMontoLimite}
                                formatoSeparadorMiles={formatoSeparadorMiles}
                              />
                            </div>
                            <div className="col-lg-4">
                              <Rubro
                                rubroList={rubroList}
                                onChangeCheckbox={this.onChangeCheckbox}
                              />
                            </div>
                            <div className="col-lg-4">
                              <Pais
                                paisList={paisList}
                                onChangeCheckbox={this.onChangeCheckbox}
                              />
                            </div>
                          </div>
                        </>
                      )
                    }
                  </div>
                  <div className="card-footer">
                    <div className="row">
                      <div className="col-lg-10 col-md-8"></div>
                      <div className="col-lg-2 col-md-4">
                        {
                          (estadoSwitchTarjeta &&
                            <BotonGuardar
                              disabled={disabledBtnGuardar}
                              onClick={this.cargarParametrosTarjeta}
                            >
                              <FontAwesomeIcon icon={faArrowAltCircleUp} />  Cambiar parámetros
                            </BotonGuardar>
                          )
                        }
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </section >

      </div >
      );
  }
}